module.exports = __webpack_public_path__ + "static/media/ntue_workshop.ae59f156.jpg";